const { detect } = require('detect-browser');
const browser = detect();

export default function getBrowserDetails (){
    return JSON.stringify({
        'browser_name': browser.name,
        'browser_version': browser.version,
        'os': browser.os
    })
  }

// The API only accepts web | mobile | tablet | unknown, so map the user agent
// onto one of those instead of sending a free-form value.
export function getDeviceType() {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';

    if (/iPad|Tablet|PlayBook|Silk/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua))) {
        return 'tablet';
    }
    if (/Mobi|Android|iPhone|iPod|Windows Phone|BlackBerry|Opera Mini|IEMobile/i.test(ua)) {
        return 'mobile';
    }
    return ua ? 'web' : 'unknown';
}